import { Link } from "react-router-dom";
import { songInfo } from "@/mocks/festival";

export default function SongHero() {
  return (
    <section className="relative w-full bg-primary-900 px-4 md:px-8 pt-28 pb-14 md:pt-36 md:pb-20 overflow-hidden">
      <div className="pointer-events-none absolute -right-20 -top-16 h-72 w-72 rounded-full border border-white/10 animate-floaty-slow"></div>
      <div className="pointer-events-none absolute left-[-8%] bottom-[-20%] h-72 w-72 rounded-full bg-accent-500/20 blur-3xl"></div>

      <div className="relative max-w-4xl mx-auto text-center">
        <nav className="flex items-center justify-center gap-2 text-xs text-background-300">
          <Link to="/" className="cursor-pointer hover:text-white transition-colors">
            홈
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-white">거봉가요제 참가 신청</span>
        </nav>

        <span className="mt-6 block text-xs tracking-[0.24em] text-accent-300">SONG CONTEST</span>
        <h1 className="mt-4 font-heading text-3xl md:text-5xl leading-tight text-white">
          거봉가요제 참가 신청
        </h1>
        <p className="mt-5 text-sm md:text-base leading-relaxed text-background-200">
          숨겨왔던 끼와 노래 실력을 무대에서 마음껏 뽐내보세요.
          <br className="hidden sm:block" />
          예선과 본선을 거쳐 최고의 무대를 가리는 축제의 하이라이트, 거봉가요제가 여러분을 기다립니다.
        </p>

        <div className="mt-9 flex flex-wrap justify-center gap-2.5">
          <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs md:text-sm text-white">
            {songInfo.dateText}
          </span>
          <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs md:text-sm text-white">
            {songInfo.prelimTime} / {songInfo.finalTime}
          </span>
          <span className="rounded-full border border-white/20 bg-white/10 px-4 py-2 text-xs md:text-sm text-white">
            {songInfo.venue}
          </span>
        </div>
      </div>
    </section>
  );
}